export default __webpack_public_path__ + "static/media/search.27efd94b.svg";